import { Swiper, SwiperProps } from "swiper/react/swiper-react";

type ControlledSwiperProps = SwiperProps;

const ControlledSwiper = ({ ...rest }: ControlledSwiperProps) => {
  return <Swiper {...rest}></Swiper>;
};

export default ControlledSwiper;
